// Function to set a cookie
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Days to milliseconds
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;SameSite=Lax";
}

// Check if the cookie is already set, if not, set it
if (!document.cookie.split('; ').find(row => row.startsWith('discount_code='))) {
    setCookie('discount_code', 'NOW20', 7); // Sets the cookie for 7 days
}